// plan-02 S05: grain pass — precomputed 256x256 noise tile, multiply composite — bible S13B

import type { DrawPass } from '../canvas'

const TILE_SIZE = 256
const GRAIN_ALPHA = 0.04
const ROTATE_S = 8

let tileCache: OffscreenCanvas | null = null

function buildTile(): OffscreenCanvas {
  if (tileCache) return tileCache
  const oc = new OffscreenCanvas(TILE_SIZE, TILE_SIZE)
  const c = oc.getContext('2d')!
  const img = c.createImageData(TILE_SIZE, TILE_SIZE)
  const d = img.data
  for (let i = 0; i < d.length; i += 4) {
    const v = Math.random() * 255
    d[i] = v
    d[i + 1] = v
    d[i + 2] = v
    d[i + 3] = 255
  }
  c.putImageData(img, 0, 0)
  tileCache = oc
  return oc
}

export function createGrain(): DrawPass {
  const tile = buildTile()
  let lastRotEpoch = -1
  let rotAngle = 0

  return (ctx, w, h, t): void => {
    const rotEpoch = Math.floor(t / ROTATE_S)
    if (rotEpoch !== lastRotEpoch) {
      rotAngle = (rotEpoch % 4) * (Math.PI / 2)
      lastRotEpoch = rotEpoch
    }

    ctx.save()
    ctx.globalAlpha = GRAIN_ALPHA
    ctx.globalCompositeOperation = 'multiply'

    // tile across viewport with rotation
    const pattern = ctx.createPattern(tile, 'repeat')
    if (!pattern) { ctx.restore(); return }

    ctx.translate(w / 2, h / 2)
    ctx.rotate(rotAngle)
    ctx.translate(-w / 2, -h / 2)
    ctx.fillStyle = pattern
    ctx.fillRect(-w, -h, w * 3, h * 3)
    ctx.restore()
  }
}
